<div class="page">

  <!-- SLIDESHOW (mobile: fixed full screen / desktop: left half) -->
  <div class="slides">
    <div class="slide" [class.active]="currentSlide === 0" style="background-image: url('assets/login_slide_1.jpg')"></div>
    <div class="slide" [class.active]="currentSlide === 1" style="background-image: url('assets/login_slide_2.jpg')"></div>
    <div class="slide" [class.active]="currentSlide === 2" style="background-image: url('assets/login_slide_3.jpg')"></div>
    <div class="slide" [class.active]="currentSlide === 3" style="background-image: url('assets/login_slide_4.jpg')"></div>
    <div class="slide" [class.active]="currentSlide === 4" style="background-image: url('assets/login_slide_5.jpg')"></div>
  </div>
  <div class="hero-overlay"></div>

  <!-- HERO TEXT (sits above slideshow) -->
  <div class="hero">
    <div class="logo">
      <img src="assets/logo white.png" alt="Picaggo" class="hero-logo-img" />
      <span class="logo-text">Picaggo</span>
    </div>

    <div class="hero-text">
      <h1 class="hero-headline">Every photo, from<br>every guest &mdash;<br><em>in one place.</em></h1>
      <p class="hero-sub">Guests shoot with their camera. Picaggo brings it all together &mdash; AI face search, live photo wall, and more.</p>
      <div class="dots">
        <div class="dot" [class.active]="currentSlide === 0" (click)="goTo(0)"></div>
        <div class="dot" [class.active]="currentSlide === 1" (click)="goTo(1)"></div>
        <div class="dot" [class.active]="currentSlide === 2" (click)="goTo(2)"></div>
        <div class="dot" [class.active]="currentSlide === 3" (click)="goTo(3)"></div>
        <div class="dot" [class.active]="currentSlide === 4" (click)="goTo(4)"></div>
      </div>
    </div>
  </div>

  <!-- CARD -->
  <div class="card-wrap">
    <div class="auth-card">

      <div class="card-logo">
        <img src="assets/logo_v2.png" alt="Picaggo" height="32" />
      </div>

      <h2 class="card-title">Sign in to Picaggo</h2>
      <p class="card-sub">Access your event albums and share memories with everyone.</p>

      <div class="proof">
        <div class="avatars">
          <div class="avatar"><img src="assets/login_slide_1.jpg" alt="" /></div>
          <div class="avatar"><img src="assets/login_slide_2.jpg" alt="" /></div>
          <div class="avatar"><img src="assets/login_slide_3.jpg" alt="" /></div>
          <div class="avatar"><img src="assets/login_slide_4.jpg" alt="" /></div>
        </div>
        <div class="proof-text"><strong>Thousands of hosts</strong> already sharing their memories</div>
      </div>

      <div class="auth-btns">
        <button class="auth-btn btn-google" (click)="signUpWithGoogle()">
          <svg class="google-g" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        <button class="auth-btn btn-apple" (click)="signUpWithApple()">
          <svg width="20" height="20" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.8917 23.9959C18.7484 25.1043 17.5 24.9293 16.2984 24.4043C15.0267 23.8676 13.86 23.8443 12.5184 24.4043C10.8384 25.1276 9.9517 24.9176 8.94836 23.9959C3.25503 18.1276 4.09503 9.19094 10.5584 8.86427C12.1334 8.94594 13.23 9.7276 14.1517 9.7976C15.5284 9.5176 16.8467 8.7126 18.3167 8.8176C20.0784 8.9576 21.4084 9.6576 22.2834 10.9176C18.6434 13.0993 19.5067 17.8943 22.8434 19.2359C22.1784 20.9859 21.315 22.7243 19.88 24.0076L19.8917 23.9959ZM14.035 8.79427C13.86 6.1926 15.9717 4.04594 18.3984 3.83594C18.7367 6.84594 15.6684 9.08594 14.035 8.79427Z" fill="#030A19"/>
          </svg>
          Continue with Apple
        </button>
      </div>

      <p class="legal">By continuing, you agree to our
        <a href="https://picaggo.com/termsofuse.html">Terms of Service</a> and
        <a href="https://picaggo.com/termsofuse.html">User Agreement</a>,
        and acknowledge our
        <a href="https://picaggo.com/PrivacyPolicy.html">Privacy Policy</a>.
        You'll also receive email notifications about your events, including reminders, activity updates, and photo highlights. You can unsubscribe at any time.
      </p>
    </div>
  </div>

</div>

<div id="recaptcha-container" style="display:none"></div>

<ng-template [ngIf]="isLoading">
  <div class="lp-overlay" [class.show]="isLoading">
    <span class="lp-spinner"></span>
  </div>
</ng-template>